// WDCE-199 step 9d: money on the EFTPOS screens, which the server sends as whole cents. Formatted from the digits,
// never by Float division (D40), to match the server's number_to_currency(cents.to_d / 100):
// formatCents(123456) is "$1,234.56" and formatCents(-150) is "-$1.50".
export function formatCents(cents) {
  if (!Number.isSafeInteger(cents)) {
    throw new TypeError(`Expected a whole number of cents, not ${cents}`)
  }

  const digits = String(Math.abs(cents)).padStart(3, '0')
  const dollars = digits.slice(0, -2).replace(/\B(?=(\d{3})+$)/g, ',')

  return `${cents < 0 ? '-' : ''}$${dollars}.${digits.slice(-2)}`
}
